// extracted by mini-css-extract-plugin
module.exports = {"grid":"styles_grid__2lo5j","slot":"styles_slot__3nvap","tile":"styles_tile__3FgcJ","announcement":"styles_announcement__3Vuru"};